import { Weave } from "../../models/weave";

class ApiService {
  getTrainerResults(
    optimized: boolean,
    intl: number,
    rank: number,
    targets: {nameId: string, target: number, start: number}[]): Promise<any> {
    targets = targets.filter(x => x.target);

    let promise: Promise<any> = Promise.resolve(null);
    if (targets.length) {
        let url = 'https://wotcodeapi.azurewebsites.net/api/weavetrainer';
        url += `?time=${Math.floor(Date.now() / 60000) * 60000}`;
        url += `&optimized=${optimized}`;
        url += `&intl=${intl}`;
        url += `&rank=${rank}`;
        targets.forEach(x => url += x.start > 0 ? `&${x.nameId}=${x.target},${x.start}` : `&${x.nameId}=${x.target}`);
        promise = fetch(url).then(resp => resp.json());

        //testing - eventually remove these lines
        /*let url2 = 'https://wotcode-func.azurewebsites.net/api/weavetrainer';
        url2 += `?time=${Math.floor(Date.now() / 60000) * 60000}`;
        url2 += `&optimized=${optimized}`;
        url2 += `&intl=${intl}`;
        url2 += `&rank=${rank}`;
        targets.forEach(x => url2 += `&${x.nameId}=${x.target}`);
        fetch(url2).then(resp => resp.json()).then((data) => {});*/
    }

    promise = promise.then(data => {
      console.log(data)
      let newData: any;

      if (data) {
        newData = {
          earth: data.elements.earth,
          air: data.elements.air,
          fire: data.elements.fire,
          water: data.elements.water,
          spirit: data.elements.spirit,
          level: data.level,
          elementPracs: data.elementPracs,
          weavePracs: data.pracs,
          totalPracs: data.totalPracs,
          weavePracs2: data.typicalPracs,
          totalPracs2: data.totalTypicalPracs,
          remainderPracs: data.pracsRemainder,
          commands: data.text,
          weaves: data.routes
        }

        newData.commands = newData.commands.replace(/; $/, '').replace(/; ?/g, '\n');
        newData.weaves =  newData.weaves.map((x: any) => ({
          id: x.name.replace(/ /g, '_'),
          percentActual: x.percent,
          percentHistory: x.path.split(' '),
          pracsActual: x.pracs,
          pracsCount: x.pracs,
          percentActual2: x.typicalPercent,
          percentHistory2: x.typicalPath.split(' '),
          pracsActual2: x.typicalPracs,
          pracsCount2: x.typicalPracs
        } as Weave));
        
      } else {
        newData = {
          earth: 0,
          air: 0,
          fire: 0,
          water: 0,
          spirit: 0,
          level: 1,
          elementPracs: 0,
          weavePracs: 0,
          totalPracs: 0,
          weavePracs2: 0,
          totalPracs2: 0,
          remainderPracs: 0,
          commands: '',
          weaves: []
        };  
      }

      return newData;
    });

    return promise;
  }
}

export const weaveTrainerApi = new ApiService();
